import axios from './axios';

const DashboardService = {
    getRestaurantsByUser: async () => {
        try {
            const response = await axios.get('/userrestaurants');
            return response.data.data;
        } catch(e) {
            console.error(e);
        }        
    },
    getSummary: () => {
        
    },
    getKpi: async (id) => {
        try {
            const response = await axios.get(`/dashboard/revenue-sales/${id}?timezone=Asia/Kolkata`);
            return response.data.data;
        } catch(e) {
            console.error(e); 
        }        
    },
    getDashboardKpi: async (from, to) => {
        try {
            const response = await axios.get(`/dashboard/kpi?start=${from}&end=${to}`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }        
    },
    getCateringDashboard: async (from, to) => {
        try {
            const response = await axios.get(`/dashboard/catering?start=${from}&end=${to}`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }        
    },
    getDeliveryDashboard: async (from, to) => {
        try {
            const response = await axios.get(`/dashboard/delivery?start=${from}&end=${to}`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }        
    },
    getPosRating: async (from, to) => {
        try {
            const response = await axios.get(`/dashboard/ratings/pos?start=${from}&end=${to}`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }        
    },
    getonlineRating: async (from, to) => {
        try {
            const response = await axios.get(`/dashboard/ratings/online?start=${from}&end=${to}`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }        
    },
    getPosTips: async (from, to) => {
        try {
            const response = await axios.get(`/dashboard/tips/pos?start=${from}&end=${to}`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }        
    },
    getDeliveryTips: async (from, to) => {
        try {
            const response = await axios.get(`/dashboard/tips/delivery?start=${from}&end=${to}`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }        
    },
    getPickupTips: async (from, to) => {
        try {
            const response = await axios.get(`/dashboard/tips/pickup?start=${from}&end=${to}`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }        
    },
    getPosKpi: async (today) => {
        try {
            const response = await axios.get(`/dashboard/pos?start=${today}`);

            // const response = await axios.get(`/dashboard/pos?start=2024-08-01&end=2024-08-30`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }        
    },
    getPosKpiTime: async (start,end) => {
        try {
            // const response = await axios.get(`/dashboard/pos?start=2024-08-25`);

            const response = await axios.get(`/dashboard/pos?start=${start}&end=${end}`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }        
    },
    getPosOrder: async () => {
        try {
            // const response = await axios.get(`/dashboard/pos?start=2024-08-25`);

            const response = await axios.get(`/orders/pos`);
            return response.data;
        } catch(e) {
            console.error(e);
        }        
    },
};

export default DashboardService;